/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const prospectedPropertyResponseDtoSchema = z.object({
    "addressLine1": z.string(),
"city": z.optional(z.string()),
"state": z.optional(z.string()),
"addressLine2": z.optional(z.string()),
"zipCode": z.optional(z.string()),
"lotSizeSqFt": z.optional(z.number()),
"bathCount": z.optional(z.number()),
"bedCount": z.optional(z.number()),
"buildingName": z.optional(z.string()),
"description": z.optional(z.string()),
"garageSpaces": z.optional(z.number()),
"hoaFeeCents": z.optional(z.number()),
"currentPrice": z.optional(z.number()),
"estimatedPrice": z.optional(z.number()),
"livingAreaSqFt": z.optional(z.number()),
"neighborhood": z.optional(z.string()),
"style": z.optional(z.string()),
"type": z.optional(z.string()),
"lat": z.optional(z.number()),
"lng": z.optional(z.number()),
"yearBuilt": z.optional(z.number()),
"floor": z.optional(z.number()),
"hasDoormanAttendance": z.optional(z.boolean()),
"isLease": z.optional(z.boolean()),
"roomsTotal": z.optional(z.number()),
"coverImageUrl": z.optional(z.string()),
"mlsId": z.optional(z.string()),
"mlsSource": z.optional(z.string()),
"listingStatus": z.optional(z.string())
    })